import { MixPuzzleInstrument } from "shared/games/mixpuzzles/types";
import prettyInstrument from "util/formatters/prettyInstrument";

interface Props {
  instrument: MixPuzzleInstrument;
}

export default function MobilePatchedInTextBar({
  instrument: { instrument },
}: Props) {
  return (
    <div>
      <div className="mb-2 h-1 w-full bg-slate-300" />

      <h2 className="overflow-hidden text-ellipsis font-brik text-purple-400 ">
        <span className="block text-base leading-none text-white">
          Currently Patched In:{" "}
        </span>
        <span className="whitespace-nowrap text-4xl leading-none">
          {prettyInstrument(instrument, true)}
        </span>
      </h2>
    </div>
  );
}
